export enum EErrorCodes {
	BAD_REQUEST = 400,
	UNAUTHORIZED = 401,
	FORBIDDEN = 403,
	PAGE_NOT_FOUND = 404,
	INTERNAL_SERVER_ERRROR = 500,
	BAD_GATEWAY = 502,
}
